import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback, useEffect, useRef } from 'react';
export function useSwipe(_ref) {
  var onLeftSwipe = _ref.onLeftSwipe,
    onRightSwipe = _ref.onRightSwipe,
    onUpSwipe = _ref.onUpSwipe,
    onDownSwipe = _ref.onDownSwipe,
    _ref$yThreshold = _ref.yThreshold,
    yThreshold = _ref$yThreshold === void 0 ? 50 : _ref$yThreshold,
    _ref$xThreshold = _ref.xThreshold,
    xThreshold = _ref$xThreshold === void 0 ? 30 : _ref$xThreshold;
  var area = useRef(null);
  var xDown = useRef(null);
  var yDown = useRef(null);
  var handleTouchStart = useCallback(function (evt) {
    var _evt$touches = _slicedToArray(evt.touches, 1),
      firstTouch = _evt$touches[0];
    xDown.current = firstTouch.clientX;
    yDown.current = firstTouch.clientY;
  }, []);
  var handleTouchMove = useCallback(function (evt) {
    if (xDown.current === null || yDown.current === null) {
      return;
    }
    var _evt$touches2 = _slicedToArray(evt.touches, 1),
      firstTouch = _evt$touches2[0];
    var xUp = firstTouch.clientX;
    var yUp = firstTouch.clientY;
    var xDiff = xDown.current - xUp;
    var yDiff = yDown.current - yUp;
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > xThreshold) {
        if (onRightSwipe) {
          onRightSwipe(evt);
        }
      } else if (xDiff < -xThreshold) {
        if (onLeftSwipe) {
          onLeftSwipe(evt);
        }
      }
    } else {
      if (yDiff > yThreshold) {
        if (onUpSwipe) {
          onUpSwipe(evt);
        }
      } else if (yDiff < -yThreshold) {
        if (onDownSwipe) {
          onDownSwipe(evt);
        }
      }
    }
  }, [onLeftSwipe, onRightSwipe, onUpSwipe, onDownSwipe, yThreshold, xThreshold]);
  var handleTouchEnd = useCallback(function () {
    xDown.current = null;
    yDown.current = null;
  }, []);
  useEffect(function () {
    if (!area.current) {
      return;
    }
    var node = area.current;
    node.addEventListener('touchstart', handleTouchStart, false);
    node.addEventListener('touchmove', handleTouchMove, false);
    node.addEventListener('touchend', handleTouchEnd, false);
    return function () {
      node.removeEventListener('touchstart', handleTouchStart);
      node.removeEventListener('touchmove', handleTouchMove);
      node.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchStart, handleTouchMove, handleTouchEnd]);
  return {
    area: area
  };
}